<template>
  <!-- :class="userInfo?'btn-active' : 'btn-disabled'" -->
  <div class="topBox_btn_wrap btn-active">
    <div class="btn-item" @click="onUndo" v-prevent-re-click>
      <i class="revoke"></i>
      <span>撤销</span>
    </div>
    <div class="btn-item" @click="onRedo">
      <i class="redo"></i>
      <span>重做</span>
    </div>
    <div class="btn-item" @click="addPopupShow">
      <i class="add"></i>
      <span>添加</span>
    </div>
    <div v-popover:popover class="btn-item delete-item">
      <span class="el-icon-arrow-down"></span>
      <i class="delete"></i>
      <span>删除</span>
    </div>
    <div class="btn-item" @click="onMerge">
      <i class="merge"></i>
      <span>合并</span>
    </div>
    <div class="btn-item split-item" @click="onSplit">
      <i class="split"></i>
      <span>拆分</span>
    </div>
    <div class="btn-item search-item" @click="seekShow">
      <i class="search"></i>
      <span>查找替换</span>
    </div>
    <div class="btn-item" @click="exchangeSent">
      <i class="exchange"></i>
      <span>调换</span>
    </div>
    <div class="btn-item" @click="deleteRepeatSent">
      <i class="repeat"></i>
      <span>去重</span>
    </div>
    <div class="btn-item" @click="toAddMemory">
      <i class="save"></i>
      <span>保存</span>
    </div>
    <div v-popover:popoverDownload class="btn-item download-warp">
      <span class="el-icon-arrow-down"></span>
      <i class="download"></i>
      <span>下载</span>
    </div>
    <div v-popover:popoverKey class="btn-item shortcut">
      <i class="shortcut-key shortcut"></i>
      <span>快捷键</span>
    </div>

    <div class="change-file">
      <el-radio-group :disabled="isdisableStartAlignment" v-model="radio" class="change-radio"
                      @change="changeFileNumber">
        <el-radio :label="1">单文档</el-radio>
        <el-radio :label="2">双文档</el-radio>
      </el-radio-group>
    </div>
    <el-button type="primary" :disabled="isdisableStartAlignment"
               :class="{'disabled-startAlignment':isdisableStartAlignment}" class="startAlignment"
               @click="beginAlignment">开始对齐</el-button>
    <el-popover ref="popover" placement="bottom" popper-class="delete-popover" :close-delay="50"
                trigger="hover">
      <el-button class="delete-btn" @click="toggleBox('check')">删除</el-button>
      <el-button class="delete-all-btn" @click="toggleBox('all')">全部删除
      </el-button>
    </el-popover>
    <el-popover ref="popoverKey" trigger="hover" placement="bottom" class="keyboard-shortcut-wrap2"
                popper-class="keyboard-shortcut-wrap">
      <div class="keyboard-shortcut-inyside">
        <KeyboardShortcut />
      </div>
    </el-popover>
    <el-popover ref="popoverDownload" width="90" trigger="hover" placement="bottom"
                popper-class="align-records-popover">
      <ul class="download-warp">
        <li class="download-warp-item" v-for="(item,index) in downloadOptions" :key="index"
            @click="handleDownload(item)">
          {{item.label}}
        </li>
      </ul>
    </el-popover>
  </div>

</template>

<script>
import throttle from "@/utils/throttle"
import { mapState, mapGetters } from "vuex";
import KeyboardShortcut from "./keyboard-shortcut"

export default {
  name: "alignmentButton",
  components: { KeyboardShortcut },
  data() {
    return {
      radio: 2,
      isdisableStartAlignment: false
    }
  },
  computed: {
    ...mapState({
      fileNumber: state => state.alignment.fileNumber,
      userInfo: state => state.layout.userInfo,
      isSent: state => state.alignment.isSent
    }),
    ...mapGetters('alignRecords', [
      'downloadOptions',
    ])
  },
  created() { },
  mounted() {
    this.$nextTick(() => {
      this.isdisableStartAlignment = JSON.parse(sessionStorage.getItem('isdisableStartAlignment')) || false
      this.radio = Number(sessionStorage.getItem("myRadio" || 2))
      if (!this.radio) this.radio = 2
      this.$store.dispatch("changeFileNumber", this.radio)
    })
  },
  watch: {
    fileNumber:{
      handler(val){
        this.radio =val
      },
      deep:true
    }
  },
  methods: {
    beginAlignment() {
      this.$emit("beginAlignment")
    },
    messageFn(type, message, duration) {
      this.$message.closeAll();
      this.$message({
        type, message, duration
      })
    },
    changeFileNumber(data) {
      let myradio = Number(data)
      if (data === 1) {
        this.$store.dispatch("removeFileList")
      }
      this.$store.dispatch("changeFileNumber", myradio)
      sessionStorage.setItem("myRadio", JSON.stringify(myradio))
    },
    deleteAllSent() {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("deleteAllSent")
    },
    addPopupShow() {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("addPopupShow")
    },
    toggleBox(type) {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("toggleBox", type)
    },
    onMerge() {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("onMerge")
    },
    onSplit() {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("onSplit")
    },
    onUndo() {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("onUndo")
    },
    onRedo() {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("onRedo")
    },
    seekShow() {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("seekShow")
    },
    exchangeSent: throttle(function () {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("exchangeSent")
    }, 1000),
    deleteRepeatSent() {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("deleteRepeatSent")
    },
    toAddMemory() {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit("toAddMemory")
    },
    handleDownload({ type }) {
      if (!this.userInfo) {
        this.messageFn("warning", "请先登录", 1000)
        return
      }
      if (!this.isSent) {
        this.messageFn("warning", "请在对齐后使用", 1000)
        return
      }
      this.$emit('handleDownload', type)
    }
  }
}
</script>
<style  lang="less">
.align-records-popover {
  // box-sizing: border-box;
  padding: 0 0 4px 0;
  min-width: 50px;
  .download-warp {
    width: 100%;
    &-item {
      margin-top: 4px;
      line-height: 21px;
      text-align: center;
      cursor: pointer;
      color: #656b74;
      font-size: 14px;
      &:hover {
        background-color: #e5f1ff;
      }
    }
  }
}
</style>
<style scoped lang="less">
.topBox_btn_wrap {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;

  .disabled-startAlignment {
    background-color: #ccc;
    color: #fff;
    border-color: #ccc;
    cursor: not-allowed !important;
  }
  .startAlignment {
    padding: 0;
    margin-left: 15px;
    cursor: pointer;
    width: 91px;
    border-radius: 4px;
    height: 32px;
    // background: #0078fc;
    // border: 1px solid #0078fc;
    // color: #ffffff;
    font-size: 14px;
    margin-bottom: 12px;
  }

  .change-file {
    margin-left: 18px;
    flex: 1;
    margin-bottom: 12px;
    .change-radio {
      float: right;
      width: 192px;
      height: 32px;
      padding: 4px;
      background: #e8ebf0;
      border-radius: 4px;
      display: flex;

      .el-radio {
        height: 100%;
        width: 92px;
        margin-right: 0 !important;
        display: flex;
        color: #99a2ad;
        align-items: center;
        justify-content: center;

        /deep/ .el-radio__label {
          padding-left: 4px !important;
        }

        /deep/ .el-radio__input {
          transform: translateY(1px);
        }
      }

      .is-checked {
        color: #0078fc;
        background: #ffffff;
        box-shadow: 0 1px 4px 0 rgba(38, 42, 51, 0.08);
        border-radius: 4px;
      }
    }
  }
  .btn-item {
    cursor: not-allowed;
    font-size: 12px;
    color: #656b74;
    position: relative;
    padding-right: 16px;
    min-width: 48px;
    i {
      display: block;
      width: 20px;
      height: 20px;
      margin: 0 auto;
    }

    &::after {
      content: "";
      display: inline-block;
      width: 1px;
      height: 10px;
      position: absolute;
      top: 5px;
      left: 55px;
      background: #dfe0e6;
    }

    .revoke {
      background: url("~@/assets/imgs/alignment-icons/revoke.png") no-repeat
        center;
    }

    .redo {
      background: url("~@/assets/imgs/alignment-icons/redo.png") no-repeat
        center;
    }

    .add {
      background: url("~@/assets/imgs/alignment-icons/add.png") no-repeat center;
    }

    .delete {
      background: url("~@/assets/imgs/alignment-icons/delete.png") no-repeat
        center;
    }

    .merge {
      background: url("~@/assets/imgs/alignment-icons/merge.png") no-repeat
        center;
    }

    .split {
      background: url("~@/assets/imgs/alignment-icons/split.png") no-repeat
        center;
    }

    .search {
      background: url("~@/assets/imgs/alignment-icons/search.png") no-repeat
        center;
    }

    .exchange {
      background: url("~@/assets/imgs/alignment-icons/exchange.png") no-repeat
        center;
    }

    .repeat {
      background: url("~@/assets/imgs/alignment-icons/repeat.png") no-repeat
        center;
    }

    .save {
      background: url("~@/assets/imgs/alignment-icons/save.png") no-repeat
        center;
    }

    .download {
      background: url("~@/assets/imgs/alignment-icons/download.png") no-repeat
        center;
    }

    .shortcut-key {
      background: url("~@/assets/imgs/alignment-icons/key.png") no-repeat center;
    }
  }
  .download-warp {
    position: relative;
    padding-right: 16px;
  }
  .download-warp::after {
    left: 62px;
  }
  .shortcut {
    padding-right: 0;
  }

  .shortcut::after {
    content: "";
    width: 0;
  }

  .split-item {
    padding-right: 24px;
  }

  .search-item {
    padding-right: 24px;

    &::after {
      left: 52px;
    }
  }

  .el-icon-arrow-down {
    position: absolute;
    top: 5px;
    left: 40px;
  }

  .delete-item {
    position: relative;
    padding-right: 25px;
  }

  .delete-item::after {
    left: 65px;
  }
}

.btn-active {
  .btn-item {
    cursor: pointer;

    &:hover {
      color: #0078fc;

      .revoke {
        background: url("~@/assets/imgs/alignment-icons/revoke-active.png")
          no-repeat center;
      }

      .redo {
        background: url("~@/assets/imgs/alignment-icons/redo-active.png")
          no-repeat center;
      }

      .add {
        background: url("~@/assets/imgs/alignment-icons/add-active.png")
          no-repeat center;
      }

      .delete {
        background: url("~@/assets/imgs/alignment-icons/delete-active.png")
          no-repeat center;
      }

      .merge {
        background: url("~@/assets/imgs/alignment-icons/merge-active.png")
          no-repeat center;
      }

      .split {
        background: url("~@/assets/imgs/alignment-icons/split-active.png")
          no-repeat center;
      }

      .search {
        background: url("~@/assets/imgs/alignment-icons/search-active.png")
          no-repeat center;
      }

      .exchange {
        background: url("~@/assets/imgs/alignment-icons/exchange-active.png")
          no-repeat center;
      }

      .repeat {
        background: url("~@/assets/imgs/alignment-icons/repeat-active.png")
          no-repeat center;
      }

      .save {
        background: url("~@/assets/imgs/alignment-icons/save-active.png")
          no-repeat center;
      }

      .download {
        background: url("~@/assets/imgs/alignment-icons/download-active.png")
          no-repeat center;
      }

      .shortcut-key {
        background: url("~@/assets/imgs/alignment-icons/key-active.png")
          no-repeat center;
      }
    }
  }
}
</style>
<style lang="scss">
.delete-popover {
  padding: 0 !important;
  min-width: 110px !important;
  width: 110px !important;

  .el-button {
    width: 110px;
    height: 32px;
    padding: 0;
    border: none;
    margin: 0;
  }
}
</style>
